// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"2de295b4","375":"706b3151","382":"ba7a080f","453":"03346f77","461":"3dff7cb9"}[chunkId] + ".chunk.js";
};